<div class="msa-stat-card">
  <div class="msa-stat-card__icon">
    <ng-content select="[stat-icon]"></ng-content>
  </div>
  <div class="msa-stat-card__content">
    <div class="msa-stat-card__value">
      <ng-content select="[stat-value]"></ng-content>
    </div>
    <div class="msa-stat-card__label">
      <ng-content select="[stat-label]"></ng-content>
    </div>
  </div>
  <div class="msa-stat-card__trend">
    <ng-content select="[stat-trend]"></ng-content>
  </div>
</div>
